import { combineReducers } from "redux";
import transferHistoryReducer from "./TransferReducer";
import bankDetailsReducer from "./BankDetailsReducer";
import maxPayoutReducer from "./MaxPayoutReducer";
import payoutBankReducer from "./PayoutBankReducer";
export default combineReducers({
    transferHistoryReducer,
    bankDetailsReducer,
    maxPayoutReducer,
    payoutBankReducer,
});
